import { UploadResourceState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const initialUploadResourceState: UploadResourceState = {
  totalRecordCount: 0,
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  addEditResourceModal: {
    isOpen: false,
    isEditMode: false,
    resource: null,
  },
};
